"use client"

import { CancelNftSelectionButton } from "@/app/nft/buy/nfts-to-buy/cancel-nft-selection-button"
import { NftsToBuyMoleculeReatom } from "@/app/nft/buy/nfts-to-buy/molecule.reatom"
import { SelectedNftsToBuy } from "@/app/nft/buy/nfts-to-buy/selected-nfts-to-buy"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"

/**
 * Actions provided by props to be able to render server-side action components conditionally,
 * based on the current state of the UI.
 */
interface Props {
  buy: React.ReactNode
  sell: React.ReactNode
  makeOffer: React.ReactNode
  sweep: React.ReactNode
}

export const ToolbarActions = reatomComponent(
  ({ buy, sell, makeOffer, sweep }: Props) => {
    const { selectedNftsToBuy } = useMolecule(NftsToBuyMoleculeReatom)
    const selectedNfts = selectedNftsToBuy()

    return (
      <div className="flex @4xl:flex-row flex-col flex-wrap items-start @4xl:items-center justify-between gap-y-4">
        {sweep}
        <div className="flex flex-wrap items-center gap-x-2 gap-y-2 empty:hidden md:gap-x-3">
          {!selectedNfts.length ? (
            <>
              {makeOffer}
              {sell}
            </>
          ) : (
            <CancelNftSelectionButton />
          )}
          {buy}
          <SelectedNftsToBuy />
        </div>
      </div>
    )
  },
  "ToolbarActions",
)
